export const formUserFullName = (user) => user ? `${user.firstName} ${user.lastName}` : '';
